import { View } from '@react-pdf/renderer';

import { styles } from '../styles';

type PartInformationProps = {
  children: React.ReactNode;
};

export function PartInformation({ children }: PartInformationProps) {
  return (
    <View
      style={[
        styles.gap10,
        styles.column,
        { flex: 1, justifyContent: 'space-between' },
      ]}
    >
      <View>{children}</View>
    </View>
  );
}
